import { createElement } from '../core/utils/dom.js';

export function breadcrumbs(items) {
  const nav = createElement('nav', {
    className: 'breadcrumb',
    attributes: { 'aria-label': 'مسار التنقل' }
  });
  const list = createElement('ol', { className: 'breadcrumb-list' });

  const entries = Array.isArray(items) ? items : [];
  entries.forEach((item, index) => {
    const li = createElement('li', { className: 'breadcrumb-item' });
    const isLast = index === entries.length - 1;
    if (!isLast && item.href) {
      li.appendChild(createElement('a', {
        className: 'breadcrumb-link',
        text: item.label,
        attributes: { href: item.href }
      }));
    } else {
      const current = createElement('span', {
        className: 'breadcrumb-current',
        text: item.label
      });
      if (isLast) current.setAttribute('aria-current', 'page');
      li.appendChild(current);
    }
    list.appendChild(li);
  });

  nav.appendChild(list);
  return nav;
}
